import { patersonConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function PatersonPage() {
  return <CityPageTemplate config={patersonConfig} />;
}